import { getGradientClass } from "@/shared/utils/avatarColorUtil";
import { camelCaseToHuman, getInitials, pascalToHuman } from "@/shared/utils/stringUtils";
import type { App } from "vue";

/**
 * Register types at vue-globals.d.ts before using this utility
 * @param app Vue application instance
 */

export function setupUtility(app: App) {
    // Register utility functions globally
    app.config.globalProperties.$pascalToHuman = pascalToHuman;
    app.config.globalProperties.$camelCaseToHuman = camelCaseToHuman;
    app.config.globalProperties.$getInitials = getInitials;
    app.config.globalProperties.$getGradientClass = getGradientClass;
}